import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Modal genérico de sucesso — contraparte do ErrorModal para confirmar respostas bem-sucedidas das APIs.
const SuccessModal = ({ isOpen, message, title = 'Sucesso!', closeSuccessModal, className }) => (
    <Modal isOpen={isOpen} toggle={closeSuccessModal} className={className} centered>
        <ModalHeader toggle={closeSuccessModal}>{title}</ModalHeader>
        <ModalBody className="text-center py-4">
            <i className="fas fa-check-circle fa-3x text-success mb-3"></i>
            <p className="m-0">{message}</p>
        </ModalBody>
        <ModalFooter>
            <button className="btn btn-outline-success" onClick={closeSuccessModal}>Ok</button>
        </ModalFooter>
    </Modal>
);

export default SuccessModal;
